const initState = {
  resumes: [
    { id: "1", title: "Resume One", content: "Software Engineering Resume" },
    { id: "2", title: "Resume 2", content: "Software Engineering Resume" },
    { id: "3", title: "Resume 3", content: "Software Engineering Resume" }
  ]
};

const resumeReducer = (state = initState, action) => {
  switch (action.type) {
    case "CREATE_RESUME":
      console.log("Created resume", action.resume);
      return state; 
    case "CREATE_RESUME_ERROR":
      console.log("Create resume error:", action.err);
      return state;
    default:
      return state;
  }
};

export default resumeReducer;
